module.exports = __webpack_public_path__ + "img/companyLogo.cf15c636.png";